import { CommonPaginationConfig } from "../utils/enums.utils";
import { LoggedInUserModel } from "../utils/models/logged-in-user.model";
import { CustomDirectiveConfig } from "./app-models.model";

export abstract class PrimeNgTableVariablesModel {
    selectedTabIndex?: any = 0;
    totalRecords: number = 0;
    selectedRow?: string;
    loggedInUserData: LoggedInUserModel;
    status?: any = [{ label: 'Active', value: true }, { label: 'Inactive', value: false }];
    dataList:any = [];
    selectedColumns = [];
    selectedRows?:any= [];
    loading?= false;
    pageLimit = [10, 25, 50, 75, 100];
    primengTableConfigProperties: any = {};
    row?: any = {};
    first?: number = 0;
    reset?: boolean;
    isShowNoRecord?: boolean;
    pageSize = +CommonPaginationConfig.defaultPageSize;
    requestParams:any = {};
    // start logic table fields search persistant
    tableFilteredFields: any = {};
    areColumnFiltersEdited = false;
    isANumberWithZero = new CustomDirectiveConfig({
        isANumberWithZero: true,
      });
    // end logic table fields search persistant
}